module.exports = __webpack_public_path__ + "static/media/footerLogo.c9a8e77d.svg";